<template>
    <div class="bindPage">
        <div class="layout">
            <v-search
                :formContent="formContent"
                :SearchForm="SearchForm"
                :inline="true"
                :optareBtn="optareBtn"
                :treePathObj="treePathObj"
                @resetFn="resetFn"
                @confirmFn="getListFn"
                @searchFn="getListFn"
                @netFn="netFn"
                @stopFn="stopFn"
                @detailFn="detailFn"
            />
            <div class="componentPage">
              <BindTable :table-data='tableData' :loading='loading' @stopUseFn="stopUseFn"
                         @choozeTable="choozeTable" @configFn="configFn" @detailFn="detailFn"></BindTable>
              <Pagination class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart"
                          :limit.sync="SearchForm.iDisplayLength" @pagination="getListFn"></Pagination>
            </div>
</div>
<Config :isShowConfig.sync="isShowConfig" :title="title" :rowData="rowData" v-bind="$attrs" ref="config" v-if="isShowConfig" />
<!-- 网络参数 -->
<Net :isShow.sync="isNetShow" :title="title" :choozeTableData="choozeTableData" ref="net" />
</div>
</template>

<script>
import formMixin from '@/utils/formMixins.js'
import getAllTreePath from '@/utils/getAllTreePath.js'
import bus from '@/utils/bus.js'
import { relayList, relayEdit } from '@/api/modules/relay.js'
import { carrierDetail } from '@/api/modules/carrier.js'
import Config from '../components/ConfigDialog.vue'
import Net from '../components/VNet.vue'
import qs from 'qs'
import { searchCondi } from '../config/bindTable'
import BindTable from '@/pages/equipment/relay/bind/bindTable.vue'
export default {
  mixins: [formMixin, getAllTreePath],
  components: {
    BindTable,
    Config,
    Net
  },
  props: {
    selectDeviceType: {
      type: Array
    }
  },
  watch: {
    selectDeviceType: {
      handler (newval) {
        this.formContent[1].selectParam = newval
      }
    },
    immediate: true
  },
  data () {
    return {
      relayList,
      // detailDialog的三个控制变量
      isDetailShow: false,
      detailObj: {},
      netObj: {},
      formContent: searchCondi,
      SearchForm: {
        code: null,
        scopeName: this.$store.state.SchemaTree[0].sceneCode === 'all_node' ? null : this.$store.state.SchemaTree[0].label,
        type: null,
        carrierName: null,
        status: null,
        configStatus: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      },
      total: 0,
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.stop',
          method: 'stopFn'
        },
        {
          id: 2,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.net_param',
          method: 'netFn'
        }
      ],
      choozeTableData: [],
      rowData: {},
      // 配置信息
      isShowConfig: false,
      isNetShow: false,

      // 监测点详情
      dialogVisible: false,
      carrierDetail: null,
      isLoading: false,
      deviceType: {},
      deviceProperty: {}
    }
  },
  mounted () {
    bus.$off('nodeClickFn')
    bus.$on('nodeClickFn', row => {
      // 获取完整的路径
      this.getAllPath(row)
      this.treeClickSearchFn(row)
    })
    if (this.sysAdmin === 'noSysNoAdmin') {
      this.optareBtn.pop()
    }
  },
  methods: {
    /** 分页 */
    getListFn () {
      this.loading = true
      relayList(this.SearchForm, 'bind').then(({ result }) => {
        this.tableData = result.result
        this.total = result.pageInfo.total
      }).finally(() => {
        this.loading = false
      })
    },
    /** 点击树形查询 */
    treeClickSearchFn (row) {
      if (row.id === 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = null
      }
      // 一级范围
      else if (row.level === 0 && row.id !== 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = row.label
      } else {
        this.SearchForm.scopeName = null
        this.SearchForm.sceneId = row.sceneId
      }
      this.getListFn()
    },
    resetFn () {
      this.SearchForm = {
        name: null,
        type: null,
        scopeName: this.$store.state.SchemaTree[0].sceneCode === 'all_node' ? null : this.$store.state.SchemaTree[0].label,
        carrierName: null,
        status: null,
        configStatus: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      }
      bus.$emit('initTree')
      this.treePathObj = this.$store.state.SchemaTree[0].sceneCode === 'all_node' ? null : this.$store.state.SchemaTree[0].label
      this.getListFn()
    },
    choozeTable (row) {
      this.choozeTableData = row
    },
    async stopUseFn (row) {
      await this.$confirm('你确定要停止使用吗?')
      const query = qs.stringify({ ids: row.id })
      relayEdit(query, 'unused').then(async ({ state }) => {
        await this.$resultHandle(state)
        this.getListFn()
      })
    },
    configFn (row) {
      this.rowData = { ...row }
      this.isShowConfig = true
      this.title = $t('public.config_info')
      this.$nextTick(() => {
        this.$refs.config.activeName = 'ConfigNet'
      })
    },

    /** 多条停用 */
    stopFn () {
      if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      const idList = this.choozeTableData.map(item => item.id)

      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          const query = qs.stringify({ ids: idList.join(',') })
          relayEdit(query, 'unused').then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 网络参数弹出框 */
    netFn () {
      if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      this.isNetShow = true
      this.title = this.$t('device.add_net_param')
      this.$nextTick(() => {
        this.$refs.net.clearValidate()
      })
    },
    /** 详情 */
    detailFn (row) {
      this.isDetailShow = true
      bus.$emit('relayParam', row.id, row.relayCode)
    },
    /** 查找监测点详情 */
    carrierDetailFn (row) {
      const { type, carrierId } = row
      this.dialogVisible = true
      this.isLoading = true

      carrierDetail(type, carrierId)
        .then(({ result }) => {
          this.carrierDetail = result
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleClose () {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.bindPage {
    width: 100%;
    height: 100%;
    padding-right: 15px;
    box-sizing: border-box;
    .layout {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
    }

    .componentPage {
        flex: 1;

        .pagination {
            padding-top: 0;
            padding-right: 15px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
}
</style>
